import * as React from 'react';
import { ContentView, } from '@levelapp/softfabric';
import ButtonImportFileMobileViewStyle from './ButtonImportFileMobileViewStyle';
import ButtonImportFileMobileViewModel from './ButtonImportFileMobileViewModel';
import { View, Text } from 'react-native';
export default class ButtonImportFileMobileView extends ContentView {
    /* CONSTRUCTOR */
    constructor(props) {
        super(props);
        // Binding
        this.bind(new ButtonImportFileMobileViewModel(this), new ButtonImportFileMobileViewStyle(this));
    }
    /* RENDERING */
    render() {
        return (React.createElement(View, null,
            React.createElement(Text, null, "This component doesn't work on mobile.")));
    }
}
